import { SUPER_ADMIN } from "@/components/data/constants";

export const REACTIVE_HIRE_REP_ROLES = ["Reactive Hirer", "Reactive Hirer (Post)"];

export function isReactiveHireRep(
  userRoles: string[] | undefined,
  userType: string | null | undefined,
): boolean {
  if (userType === SUPER_ADMIN) return true;
  return (userRoles ?? []).some((role) => REACTIVE_HIRE_REP_ROLES.includes(role));
}
